export const environment = {
  production: false,
  version: '20260213104355-d9530d604e76198780442cf83f6fb670ab09cba9'
};
